import React from 'react'

import { Dialog } from 'primereact/dialog'

import DialogFooter from '../dialogFooter'
import * as popUp from '../toastr'
import HandleErrorService from '../../app/service/handleErrorService'
import GrupoDePagamentoService from '../../app/service/contasAPagar/grupoDePagamentoService'
import GeneralServices from '../../app/service/generalServices'
import ConstantsUtil from '../../context/constantsUtil'
import CheckBoxComponent from '../relatorios/checkBoxComponent'
import SelectMenu from '../selectMenu'
import CadastroContasAPagarService from '../../app/service/central/cadastroContasAPagarService'
import AuthService from '../../app/service/authService'
import InputChooseTipoDreCompetencia from './inputChooseTipoDreCompetencia'

class EditOrCreateGrupoDePagamentoDialog extends React.Component {

    constructor(){
        super()
        this.grupoDePagamentoService = new GrupoDePagamentoService()
        this.cadastroContasAPagarService = new CadastroContasAPagarService()
        this.generalServices = new GeneralServices()
    }

    state = {
        id: null,

        nome: '',
        inputNomeErrorClass:'',
        errorNomeMessage: 'Digite o nome',

        destacadoDRE: false,

        ausenteDRECompetencia: false,

        tipoDreCompetencia: '',
        inputTipoDreCompetenciaErroClass: '',

        uuidUnificado: '',

        isSaving: false,

    }

    componentDidUpdate(){
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){

            if(this.props.state){
                // console.log("state: ", this.props.state)
                this.resetView()
                this.setState({id: this.props.state.id})
                this.setState({nome: this.props.state.nome})
                this.setState({destacadoDRE: this.props.state.destacadoDRE})
                this.setState({ausenteDRECompetencia: this.props.state.ausenteDRECompetencia})
                this.setState({tipoDreCompetencia: this.props.state.tipoDreCompetencia})
                this.setState({uuidUnificado: this.props.state.uuidUnificado})
            }
                
            this.setState({didUpdated: true})
            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }
        }
    }

    hideDialog = () => {
        this.setState({didUpdated: false})
        this.props.hideDialog()
    }

    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleSelectionTipoDreCompetenciaChange = (selectedTipoDreCompetencia) => {
        // console.log("selectedTipoDreCompetencia: ", selectedTipoDreCompetencia)
        this.setState({tipoDreCompetencia: selectedTipoDreCompetencia})
    }

    handleKeyUp = async (event) => {
        
        await this.generalServices.sleep(100)

        if(this.state.isSaving){
            return
        }

        if(event.code === "Enter" || event.code === "NumpadEnter"){
            this.callSave()
        }
    }

    resetView = () => {
        this.setState({inputNomeErrorClass: ''})
        this.setState({inputTipoDreCompetenciaErroClass: ''})
    }

    resetData = () => {
        this.setState({
            nome: '',
            destacadoDRE: '',
            ausenteDRECompetencia: '',
            tipoDreCompetencia: '',
            uuidUnificado: '',
        })
    }

    checkData = () => {
        var check = true

        if(!this.state.nome){
            this.setState({inputNomeErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if(!this.state.tipoDreCompetencia){
            this.setState({inputTipoDreCompetenciaErroClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        return check

    }

    callSave = async () => {
        this.resetView()
        if(this.checkData()){

            await this.generalServices.sleep(100)
            if(this.state.isSaving){
                return
            }

            if(this.props.dialogType === ConstantsUtil.tipoDialogGrupoDePagamentoCreateLabel){
                this.create()
            }
            else{
                this.update()
            }
        }
    }

    create = () => {
        AuthService.startBlockUi()
        this.setState({isSaving: true})
        this.cadastroContasAPagarService.createGrupoDePagamento(
            {
                nome : this.state.nome.trim().toUpperCase(),
                destacadoDRE: this.state.destacadoDRE,
                ausenteDRECompetencia: this.state.ausenteDRECompetencia,
                tipoDreCompetencia: this.state.tipoDreCompetencia
            }
        )
        .then(response => {
            popUp.successPopUp("Grupo de Pagamento cadastrado com sucesso!")
            this.hideDialog()
            this.resetData()
            this.props.search()
            // this.resetForm()
            // this.search()
            // this.inputNome.current.focus()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(async () => {
            await this.generalServices.sleep(1000)
            this.setState({isSaving: false})
            AuthService.stopBlockUi()
        })
    }

    update = () => {

        AuthService.startBlockUi()
        this.setState({isSaving: true})

        let obj =
        {
            id: this.state.id,
            nome: this.state.nome.trim().toUpperCase(),
            destacadoDRE: this.state.destacadoDRE,
            ausenteDRECompetencia: this.state.ausenteDRECompetencia,
            tipoDreCompetencia: this.state.tipoDreCompetencia,
            uuidUnificado: this.state.uuidUnificado
        }

        // console.log("obj: ", obj)

        this.cadastroContasAPagarService.updateGrupoDePagamento(obj)
        .then(async response => {
            popUp.successPopUp("Grupo de Pagamento alterado com sucesso!")
            this.props.search()
            this.hideDialog()
            this.setState({didUpdated: false})

            await this.generalServices.sleep(1000)
            this.setState({isSaving: false})

        }).catch(async error => {
            await this.generalServices.sleep(1000)
            this.setState({isSaving: false})
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
        this.setState({didUpdated: false})
    }

    render () {

        const editTipoRecebimentoDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {this.hideDialog} disabled={this.props.disabled}/>
        )

        return (
            <>
            <Dialog visible={this.props.visible} style={{ width: '450px' }}
                    header={this.props.header ? this.props.header : "Cadastrar Grupo de Pagamento"}
                    modal
                    className="p-fluid"
                    footer={editTipoRecebimentoDialogFooter}
                    onHide={this.hideDialog}>

                <div className="p-field">
                    <label htmlFor="nome">Nome</label>
                    <input style={{color: '#000'}}
                            type="text"
                            className={"form-control " + this.state.inputNomeErrorClass}
                            id="nome"
                            autoFocus
                            value = {this.state.nome}
                            name="nome"
                            onChange={this.handleChange}
                            onKeyDown={this.handleKeyUp}
                            // onKeyDown={this.handleKeyUp}
                            disabled={this.props.disabled}
                            />
                    <div className="invalid-feedback">{this.state.errorNomeMessage}</div>
                </div>

                <br />
                <div className="p-field">
                    {/* <SelectMenu
                        className={"form-control " + this.state.inputTipoDreCompetenciaErroClass}
                        name="tipoDreCompetencia"
                        list={GeneralServices.tipoDreCompetenciaGrupoDePagamentoSelectList()} 
                        value={this.state.tipoDreCompetencia}
                        onChange={this.handleChange}
                        // disabled
                    /> */}
                    <InputChooseTipoDreCompetencia
                        selectedTipoDreCompetenciaLabel={this.state.tipoDreCompetencia.descricao}
                        handleSelectionTipoDreCompetenciaChange={this.handleSelectionTipoDreCompetenciaChange}
                    />
                    <div className="invalid-feedback">Informe o Tipo DRE</div>
                </div>

                <br />
                <div className="col-md-12">
                <CheckBoxComponent
                    label={ConstantsUtil.destacadoNoDRECheckBoxLabel}
                    checked={this.state.destacadoDRE}
                    handleCheckBoxChange={(checked) => this.setState({destacadoDRE: checked})}
                />
                </div>

                <br />
                <div className="col-md-12">
                <CheckBoxComponent
                    label={ConstantsUtil.ausenteNoDREPorCompetenciaCheckBoxLabel}
                    checked={this.state.ausenteDRECompetencia}
                    handleCheckBoxChange={(checked) => this.setState({ausenteDRECompetencia: checked})}
                />
                </div>

            </Dialog>
            
            </>
        )    
    }

}

export default EditOrCreateGrupoDePagamentoDialog